var map = {
	"./bg.json": [
		5922,
		922
	],
	"./cs.json": [
		58,
		58
	],
	"./da.json": [
		4443,
		443
	],
	"./de.json": [
		5995,
		995
	],
	"./el.json": [
		4682,
		682
	],
	"./en.json": [
		8534,
		534
	],
	"./es.json": [
		9050,
		50
	],
	"./fr.json": [
		7843,
		843
	],
	"./hr.json": [
		4725,
		725
	],
	"./hu.json": [
		356,
		356
	],
	"./it.json": [
		6595,
		595
	],
	"./lv.json": [
		9345,
		345
	],
	"./nb_NO.json": [
		4454,
		454
	],
	"./nl.json": [
		9080,
		80
	],
	"./pl.json": [
		1722,
		722
	],
	"./pt.json": [
		4907,
		907
	],
	"./pt_BR.json": [
		32,
		32
	],
	"./ro.json": [
		2072,
		72
	],
	"./ru.json": [
		6830,
		830
	],
	"./sk.json": [
		2389,
		389
	],
	"./sv.json": [
		2235,
		235
	],
	"./tr.json": [
		9972,
		972
	],
	"./uk.json": [
		3662,
		662
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6470;
module.exports = webpackAsyncContext;